/** Anything that advances its own state once per animation frame. */
export interface Updatable {
  /** @param dt elapsed time since the previous frame, in seconds. */
  update(dt: number): void;
}

export type WebSide = 'L' | 'R';
export const WEB_SIDES: readonly WebSide[] = ['L', 'R'];
